module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAICAYAAADnVO9eAAAAb0lEQVQ4T7XSsQ2AMBADQHseyryoGIGaBViAmgb2YBkk2kxCnzZG6ZNUzw/gk60nHM7MdkkbySXGeNci6eDAzA5JJ4BEcq5hLhAAhhAuAGsL84LKMF3ME+pi3lATK3UfAJPHUzQyUs55+B2S9EoaP3zMN20rzp+MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/home/assets/arrow.png
// module id = 4hPi
// module chunks = 4